export default __webpack_public_path__ + "static/media/outside.0b3fd247.png";